export class OwnerIdeasDraftDeleteRequest {
  ideaId: string

  constructor(id: string) { this.ideaId = id }
}
